import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['ToyManager']['getModel']
type inputType = RouterInputs['ToyManager']['getModel']

export const useGetModel = (input: inputType, options?: optionsType) =>
    api.ToyManager.getModel.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.getModel', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
    })
